  const configure = {
    baseurl:'https://jhl.exchange:8081'
    //baseurl:'https://81.68.191.155:8081'
    //baseurl:'http://192.168.0.115:8081'
  }
  function formatXml(text) {
  　　return text
  }
  export {configure,formatXml}